import {action, observable} from "mobx";
import {ICart} from "../models/cart/cart";
import {ICartItem} from "../models/cart/cart-item";
import {ICartRow} from "../models/cart/cart-row";
import {NoticeTypeEnum} from "../models/notice";
import BaseStore from "./base/base-store";
import RootStore from "./root-store";

export default class CartStore extends BaseStore {

    @observable
    public cart: ICart;

    constructor(rootStore: RootStore) {
        super(rootStore);
        this.setCart();
    }

    public addToCart(item: ICartItem, qty: number) {
        const valid = this.validateCartItem(item, qty);

        if (valid) {
            const row = {
                item: item,
                qty: qty
            };

            this.addCartRow(row);
            localStorage.setItem('cart', JSON.stringify(this.cart));
            this.notify(NoticeTypeEnum.Success, this.rootStore.translationStore.translate("cart.added", "{0} added to cart", item.product.name));
        }
    }

    @action
    public removeFromCart(idx: number) {
        this.cart.rows.splice(idx, 1);
        localStorage.setItem('cart', JSON.stringify(this.cart));
    }

    public calculateSubTotal(): number {
        let total = 0;
        this.cart.rows.forEach(x => total = total + (x.item.product.price * x.qty));
        return total;
    }

    @action
    public resetCart() {
        const today = new Date();
        const expirationDate = new Date(today.setDate(today.getDate() + 1));

        this.cart = {
            rows: [],
            expires: expirationDate
        };

        localStorage.removeItem('cart');
        localStorage.setItem('cart', JSON.stringify(this.cart));
    }

    @action
    private addCartRow(row: ICartRow) {
        this.cart.rows.push(row);
    }

    private validateCartItem(item: ICartItem, qty: number): boolean {
        const rootStore = this.rootStore;
        const parameters = rootStore.productStore.parameters;

        if (!item.product.price) {
            this.notify(NoticeTypeEnum.Failure, "Cannot add priceless product to cart");
            return false;
        }

        for (const parameter of parameters) {
            const selectedParameter = item.parameters.find(x => x.name === parameter.name);

            if (!selectedParameter) {
                this.notify(NoticeTypeEnum.Failure, `${parameter} is not selected`);
                return false;
            }
        }

        const currentProduct = rootStore.productStore.productDetails;

        if (currentProduct.stockable && qty > currentProduct.stock) {
            this.notify(NoticeTypeEnum.Failure, rootStore.translationStore.translate("product.out-of-stock", `Only ${currentProduct.stock} ${item.product.name} left`));
            return false;
        }

        return true;
    }

    private setCart() {
        this.cart = JSON.parse(localStorage.getItem('cart'));
        const cart = this.cart;

        if (cart && cart.expires) {
            this.validateCart();
        } else {
            this.resetCart();
        }
    }

    private validateCart() {
        const today = Date.parse(new Date().toISOString());

        try {
            const expirationDate = Date.parse(this.cart.expires.toString());

            if (today > expirationDate) {
                this.resetCart();
            }
        } catch (e) {
            this.notify(NoticeTypeEnum.Failure, e);
            this.resetCart();
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/cart-store.ts